
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("7NfJC", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $cfe1f120a2e1ad85$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $8bG3p = parcelRequire("8bG3p");
const $cfe1f120a2e1ad85$var$LoomPanel = ({ props: props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8bG3p.LoomPanel), props);
var $cfe1f120a2e1ad85$export$2e2bcd8739ae039 = $cfe1f120a2e1ad85$var$LoomPanel;

});
parcelRegister("8bG3p", function(module, exports) {

$parcel$export(module.exports, "LoomPanel", () => $1deecbffaa279937$export$761622e58ea33251);

var $eJOHy = parcelRequire("eJOHy");

var $e2B2h = parcelRequire("e2B2h");

var $aT3dd = parcelRequire("aT3dd");

var $lYpjS = parcelRequire("lYpjS");

var $kHdo2 = parcelRequire("kHdo2");

var $hz2Wc = parcelRequire("hz2Wc");

var $bJscI = parcelRequire("bJscI");

var $43oFD = parcelRequire("43oFD");

var $3u1hh = parcelRequire("3u1hh");
// Loom panel that launched with M2.5
const $1deecbffaa279937$var$LoomPanelOld = ()=>{
    const { loomTouchpointVariant: loomTouchpointVariant } = (0, $aT3dd.useLoomTouchpointWithProjectType)();
    if (loomTouchpointVariant === (0, $kHdo2.LoomTouchpointVariant).NONE) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $e2B2h.default), {
        data: {
            attributes: {
                loomTouchpointVariant: loomTouchpointVariant
            }
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3u1hh.LoomCoUsePanel), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hz2Wc.LoomRecorderLoadingBlanket), null));
};
// Feature gated Loom panel component for Loom JSM agent experiment
const $1deecbffaa279937$var$LoomPanelWithJSM = ()=>{
    const { loomTouchpointVariant: loomTouchpointVariant } = (0, $lYpjS.useLoomTouchpointVariant)();
    const { showCoUsePanel: showCoUsePanel, showLoadingBlanket: showLoadingBlanket } = (0, $43oFD.useLoomSupportedProjectType)();
    if (loomTouchpointVariant === (0, $kHdo2.LoomTouchpointVariant).NONE || !showCoUsePanel && !showLoadingBlanket) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $e2B2h.default), {
        data: {
            attributes: {
                loomTouchpointVariant: loomTouchpointVariant,
                showLoomCoUsePanel: showCoUsePanel,
                showLoomLoadingBlanket: showLoadingBlanket
            }
        }
    }, showCoUsePanel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3u1hh.LoomCoUsePanel), null), showLoadingBlanket && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hz2Wc.LoomRecorderLoadingBlanket), null));
};
const $1deecbffaa279937$export$761622e58ea33251 = (0, $bJscI.componentWithFG)('loom_jsm_experiment_controller', $1deecbffaa279937$var$LoomPanelWithJSM, $1deecbffaa279937$var$LoomPanelOld);

});
parcelRegister("hz2Wc", function(module, exports) {

$parcel$export(module.exports, "LoomRecorderLoadingBlanket", () => $d43a192eff765ebe$export$333b15e6d765b856);

var $eJOHy = parcelRequire("eJOHy");

var $5Lo0w = parcelRequire("5Lo0w");

var $67YQP = parcelRequire("67YQP");

var $dLR8J = parcelRequire("dLR8J");

var $dPMMf = parcelRequire("dPMMf");

var $3963y = parcelRequire("3963y");
const $d43a192eff765ebe$export$333b15e6d765b856 = ()=>{
    const [{ isBlanketShown: isBlanketShown, isPolling: isPolling }] = (0, $3963y.useLoomRecorderLoadingBlanket)();
    // the blanket has to be on top of everything. If we use layers.blanket, it will be behind issue view modals.
    return isBlanketShown && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $67YQP.default), {
        zIndex: (0, $dPMMf.layers).spotlight + 1
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5Lo0w.default), {
        isTinted: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dLR8J.default), {
        name: "loom-recorder-loading-blanket",
        hold: isPolling
    }));
};

});

parcelRegister("43oFD", function(module, exports) {

$parcel$export(module.exports, "useLoomSupportedProjectType", () => $d2e475467b8cc47e$export$92b42caa4f813468);

var $ln6Iy = parcelRequire("ln6Iy");

var $dyOHn = parcelRequire("dyOHn");
const $d2e475467b8cc47e$var$SUPPORTED_CO_USE_PROJECT_TYPES = [
    (0, $ln6Iy.CORE_PROJECT),
    (0, $ln6Iy.SOFTWARE_PROJECT)
];
const $d2e475467b8cc47e$var$SUPPORTED_LOADING_BLANKET_PROJECT_TYPES = [
    (0, $ln6Iy.CORE_PROJECT),
    (0, $ln6Iy.SOFTWARE_PROJECT),
    (0, $ln6Iy.SERVICE_DESK_PROJECT)
];
const $d2e475467b8cc47e$export$92b42caa4f813468 = ()=>{
    const project = (0, $dyOHn.useSelector)((state)=>state.entities?.project);
    const projectType = project?.projectType;
    const showCoUsePanel = projectType && $d2e475467b8cc47e$var$SUPPORTED_CO_USE_PROJECT_TYPES.includes(projectType);
    const showLoadingBlanket = projectType && $d2e475467b8cc47e$var$SUPPORTED_LOADING_BLANKET_PROJECT_TYPES.includes(projectType);
    return {
        showCoUsePanel: showCoUsePanel,
        showLoadingBlanket: showLoadingBlanket
    };
};

});

parcelRegister("3u1hh", function(module, exports) {

$parcel$export(module.exports, "LoomCoUsePanel", () => $43237cc27d6f0076$export$469c500eeadb1acb);

var $eJOHy = parcelRequire("eJOHy");

var $eq3Hf = parcelRequire("eq3Hf");

var $1KdDN = parcelRequire("1KdDN");

var $284TU = parcelRequire("284TU");

var $7SaXU = parcelRequire("7SaXU");

var $1IADZ = parcelRequire("1IADZ");

var $5vVYG = parcelRequire("5vVYG");

var $zkKje = parcelRequire("zkKje");

var $ljej9 = parcelRequire("ljej9");

var $fQ4Mz = parcelRequire("fQ4Mz");
const $43237cc27d6f0076$var$LOOM_APP_NAME = 'Loom';
const $43237cc27d6f0076$var$LOOM_APP_TYPE = 'com.atlassian.jira.issue.loom';
const $43237cc27d6f0076$export$ac90a5534d384989 = (0, (/*@__PURE__*/$parcel$interopDefault($eq3Hf)))((0, $284TU.connect)((state)=>({
        isInsertLoomLinkOpened: (0, $5vVYG.isInsertLoomLinkOpenedSelector)(state),
        insertLoomLinkClickedCount: (0, $5vVYG.insertLoomLinkClickedCountSelector)(state),
        links: (0, $zkKje.webLinksWithApplicationIdSelector)(state, (0, $zkKje.generateApplicationId)($43237cc27d6f0076$var$LOOM_APP_NAME, $43237cc27d6f0076$var$LOOM_APP_TYPE))
    }), (dispatch)=>({
        onInsertLink: (url)=>dispatch((0, $1IADZ.createWebLinkRequest)((0, $ljej9.toHref)(url), 'Loom video', '', {
                type: $43237cc27d6f0076$var$LOOM_APP_TYPE,
                name: $43237cc27d6f0076$var$LOOM_APP_NAME
            })),
        onDeleteLink: (id)=>dispatch((0, $1IADZ.deleteWebLinkRequest)(id)),
        onShowInsertLoomLinkForm: ()=>dispatch((0, $7SaXU.showInsertLoomLinkForm)()),
        onHideInsertLoomLinkForm: ()=>dispatch((0, $7SaXU.hideInsertLoomLinkForm)())
    })))((0, $fQ4Mz.LoomCoUseView));
const $43237cc27d6f0076$export$469c500eeadb1acb = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: "loom-videos-section-container",
        packageName: "issueViewBase",
        teamName: "bento",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($43237cc27d6f0076$export$ac90a5534d384989, props));

});
parcelRegister("5vVYG", function(module, exports) {

$parcel$export(module.exports, "insertLoomLinkClickedCountSelector", () => $37f57fc463f87d5d$export$d4e1e55c7928c872);
$parcel$export(module.exports, "isInsertLoomLinkOpenedSelector", () => $37f57fc463f87d5d$export$25945e2a4ec61683);

var $ahm5r = parcelRequire("ahm5r");

var $6az7p = parcelRequire("6az7p");
const $37f57fc463f87d5d$var$loomRootSelector = (0, $ahm5r.createSelector)((0, $6az7p.entitiesSelector), (entities)=>entities.loom);
const $37f57fc463f87d5d$export$d4e1e55c7928c872 = (0, $ahm5r.createSelector)($37f57fc463f87d5d$var$loomRootSelector, (loom)=>loom.insertLoomLinkClickedCount);
const $37f57fc463f87d5d$export$25945e2a4ec61683 = (0, $ahm5r.createSelector)($37f57fc463f87d5d$export$d4e1e55c7928c872, (insertLoomLinkClickedCount)=>insertLoomLinkClickedCount > 0);

});

parcelRegister("fQ4Mz", function(module, exports) {

$parcel$export(module.exports, "LoomCoUseView", () => $3f84d46c17f5f1a1$export$f68e18636ec96e0e);

var $eJOHy = parcelRequire("eJOHy");

var $kk5YU = parcelRequire("kk5YU");

var $78OnL = parcelRequire("78OnL");

var $gYnSx = parcelRequire("gYnSx");

var $bILK0 = parcelRequire("bILK0");

var $lRq8t = parcelRequire("lRq8t");

var $1MNtF = parcelRequire("1MNtF");

var $dNVxC = parcelRequire("dNVxC");

var $8bxUW = parcelRequire("8bxUW");

var $6d9QY = parcelRequire("6d9QY");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $6XJko = parcelRequire("6XJko");

var $8VkeW = parcelRequire("8VkeW");

var $33k2I = parcelRequire("33k2I");

var $4n0YE = parcelRequire("4n0YE");

var $7mvFA = parcelRequire("7mvFA");
function $3f84d46c17f5f1a1$var$isSmartAndNotFailedToDeleteWebLink(link) {
    return 'smartLinkId' in link && !('deleteFailed' in link);
}
const $3f84d46c17f5f1a1$export$f68e18636ec96e0e = ({ isInsertLoomLinkOpened: isInsertLoomLinkOpened, insertLoomLinkClickedCount: insertLoomLinkClickedCount, links: links, onInsertLink: onInsertLink, onDeleteLink: onDeleteLink, onShowInsertLoomLinkForm: onShowInsertLoomLinkForm, onHideInsertLoomLinkForm: onHideInsertLoomLinkForm })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const isReducedMotion = (0, $kk5YU.useIsReducedMotion)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { showFlag: showFlag } = (0, $bILK0.useFlagsService)();
    const optimisticlyCreateLinkIdRef = (0, $eJOHy.useRef)();
    const validLinks = (0, $eJOHy.useMemo)(()=>links.filter((link)=>!('isCreateFailed' in link && link.isCreateFailed)), [
        links
    ]);
    const previousLinks = (0, $6d9QY.usePrevious)(links.filter($3f84d46c17f5f1a1$var$isSmartAndNotFailedToDeleteWebLink));
    // This effect shows flags when a new Loom link is inserted (via recording or via adding an existing link)
    (0, $eJOHy.useEffect)(()=>{
        // Filtering out results of failed deletions (the link is deleted optimistically and if that fails it appears again)
        const smartLinks = links.filter($3f84d46c17f5f1a1$var$isSmartAndNotFailedToDeleteWebLink);
        if (!optimisticlyCreateLinkIdRef.current) {
            // if we're here, we search for a newly created optimistic link
            const optimisticItem = smartLinks.filter((link)=>Object.hasOwnProperty.call(link, 'isCreateFailed'))// there might be other links that the user tried and failed to create before but we only care about the latest one.
            .pop();
            if (optimisticItem && // It's the first time we ever see this link (optimistic)
            !previousLinks?.find((link)=>link.smartLinkId === optimisticItem.smartLinkId)) optimisticlyCreateLinkIdRef.current = optimisticItem.smartLinkId;
            return;
        }
        // if we're here, an optimistic link we in the previous run was sent to the server and came back with a result we want to check
        const createdItem = smartLinks.find((link)=>link.smartLinkId === optimisticlyCreateLinkIdRef.current);
        optimisticlyCreateLinkIdRef.current = undefined;
        if (!createdItem) {
            // if we got here - it is a bug, should never happen
            (0, $gYnSx.default)({
                meta: {
                    id: 'showFlagLoomOptimisticLinkLookup',
                    packageName: 'jiraIssueViewBase',
                    teamName: 'bento'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            return;
        }
        if ('isCreateFailed' in createdItem && createdItem.isCreateFailed) {
            showFlag({
                id: 'loomInsertLinkFailure',
                type: 'error',
                title: (0, $8VkeW.messages).failureTitleLinkInserted,
                description: formatMessage((0, $8VkeW.messages).failureLinkInserted),
                messageId: 'issue-view-base.content.loom-videos.ui.co-use.show-flag.error.loom-insert-link-failure',
                messageType: 'transactional'
            });
            (0, $gYnSx.default)({
                meta: {
                    id: 'loomInsertLink',
                    packageName: 'jiraIssueViewBase',
                    teamName: 'bento'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        } else showFlag({
            id: 'loomInsertLinkSuccess',
            type: 'success',
            title: (0, $8VkeW.messages).successTitleLinkInserted,
            description: formatMessage((0, $8VkeW.messages).successLinkInserted),
            messageId: 'issue-view-base.content.loom-videos.ui.co-use.show-flag.success.loom-insert-link-success',
            messageType: 'transactional',
            actions: [
                {
                    content: (0, $8VkeW.messages).successActionShare,
                    onClick: ()=>{
                        if (typeof navigator !== 'undefined') navigator.clipboard.writeText(createdItem.href);
                    }
                }
            ]
        });
    }, [
        links,
        showFlag,
        formatMessage,
        previousLinks
    ]);
    // when cross flow succeeds, open the recorder
    (0, $dNVxC.useLoomRecorderTriggerListener)((0, $8bxUW.LoomRecorderTriggerEvent).CROSS_FLOW_SUCCESS, {
        entryPointLocation: 'jiraIssueView_quickAdd_crossflow',
        // TODO confirm what we want for these strings
        // intentionally not localized because Loom RecordSDK does not support i18n
        insertButtonText: 'Add video',
        onInsert: onInsertLink
    });
    const analyticsEvent = createAnalyticsEvent({
        action: 'clicked',
        actionSubject: 'button'
    });
    // animate and offset are used to control the LoomVideosList
    const [animate, setAnimate] = (0, $eJOHy.useState)(false);
    const [offset, setOffset] = (0, $eJOHy.useState)(0);
    // handleScroll is passed to the LoomVideosList to update the animate and offset states
    const handleScroll = (0, $eJOHy.useCallback)((e)=>{
        if (e.direction === 'left') (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'loom-video-list-left-icon-button');
        else (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'loom-video-list-right-icon-button');
        setOffset(e.offset);
        if (isReducedMotion) setAnimate(false);
        else setAnimate(e.animate);
    }, [
        analyticsEvent,
        isReducedMotion
    ]);
    const handleLinkInsert = async (url)=>{
        onInsertLink(url);
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'insert-existing-loom-link-button');
        // reset the LoomVideosList to show the newly inserted link
        setOffset(0);
        if (isReducedMotion) setAnimate(false);
        else setAnimate(true);
    };
    const handleCancelLinkInsert = ()=>{
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'cancel-existing-loom-link-button');
        onHideInsertLoomLinkForm();
    };
    // only show the section heading if there are links or the insert link form is opened (this behavior is consistent with the existing web links implementation)
    const shouldShowSection = isInsertLoomLinkOpened || links.length > 0;
    const enableVisualRefreshChanges = (0, $6XJko.isVisualRefreshEnabled)();
    if (!shouldShowSection && enableVisualRefreshChanges) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $78OnL.default), {
        testId: "issue-view-base.content.loom-videos.ui.co-use.container"
    }, shouldShowSection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1MNtF.SectionHeading), {
        "data-testid": "issue-view-base.content.loom-videos.ui.co-use.heading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1MNtF.SectionHeadingTitle), null, formatMessage((0, $8VkeW.messages).loomVideosHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1MNtF.SectionHeadingIcons), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $33k2I.default), {
        onShowInsertLoomLinkForm: onShowInsertLoomLinkForm,
        onInsertLink: onInsertLink
    }))), validLinks.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7mvFA.LoomVideosList), {
        links: validLinks,
        animate: animate,
        offset: offset,
        onScroll: handleScroll,
        onDeleteLink: onDeleteLink
    }), isInsertLoomLinkOpened && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4n0YE.LoomVideoInsert), {
        insertLoomLinkClickedCount: insertLoomLinkClickedCount,
        loomLinkCount: validLinks.length,
        onInsert: handleLinkInsert,
        onCancel: handleCancelLinkInsert
    }));
};

});
parcelRegister("8VkeW", function(module, exports) {

$parcel$export(module.exports, "messages", () => $02c165dcc579951e$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $02c165dcc579951e$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    loomVideosHeading: {
        "id": "issue-view-base.content.loom-videos.loom-videos-heading",
        "defaultMessage": "Loom videos"
    },
    loomCardErrorHeading: {
        "id": "issue-view-base.content.loom-videos.loom-card-error-heading",
        "defaultMessage": "An error has occurred"
    },
    successTitleLinkInserted: {
        "id": "issue-view-base.content.loom-videos.success-title-link-inserted",
        "defaultMessage": "Your Loom video has been added!"
    },
    successLinkInserted: {
        "id": "issue-view-base.content.loom-videos.success-link-inserted",
        "defaultMessage": "Copy the link to share it with your team."
    },
    successActionShare: {
        "id": "issue-view-base.content.loom-videos.success-action-share",
        "defaultMessage": "Copy link"
    },
    // TODO - finaliaze these messages
    failureTitleLinkInserted: {
        "id": "issue-view-base.content.loom-videos.failure-title-link-inserted.non-final",
        "defaultMessage": "Failed to add your Loom video"
    },
    failureLinkInserted: {
        "id": "issue-view-base.content.loom-videos.failure-link-inserted.non-final",
        "defaultMessage": "Please try again."
    }
});

});

parcelRegister("33k2I", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef860b3667d9df56$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");

var $7rjYb = parcelRequire("7rjYb");
var $aLJ1L = parcelRequire("aLJ1L");

var $jQjGM = parcelRequire("jQjGM");

var $lRq8t = parcelRequire("lRq8t");

var $lYpjS = parcelRequire("lYpjS");

var $kHdo2 = parcelRequire("kHdo2");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $3XmZx = parcelRequire("3XmZx");

var $b9ZjM = parcelRequire("b9ZjM");

var $fjnjD = parcelRequire("fjnjD");
const $ef860b3667d9df56$var$LoomActionsMenu = ({ onShowInsertLoomLinkForm: onShowInsertLoomLinkForm, onInsertLink: onInsertLink })=>{
    const [isDropdownMenuOpen, setIsDropdownMenuOpen] = (0, $eJOHy.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { loomTouchpointVariant: loomTouchpointVariant } = (0, $lYpjS.useLoomTouchpointVariant)();
    const handleOpenChange = (0, $eJOHy.useCallback)(({ isOpen: isOpen })=>{
        setIsDropdownMenuOpen(isOpen);
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
            action: 'toggled',
            actionSubject: 'dropdownMenu'
        }), 'add-loom-icon-dropdown-menu', {
            isOpen: isOpen
        });
    }, [
        createAnalyticsEvent
    ]);
    // under cross-flow, we don't allow users to even add existing Looms
    if (loomTouchpointVariant === (0, $kHdo2.LoomTouchpointVariant).CROSSFLOW || loomTouchpointVariant === (0, $kHdo2.LoomTouchpointVariant).NONE) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7rjYb.default), {
        testId: "issue-view-base.content.loom-videos.ui.co-use.loom-actions-menu.drop-down-menu",
        defaultOpen: isDropdownMenuOpen,
        onOpenChange: handleOpenChange,
        placement: "bottom-end",
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
                ...props,
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jQjGM))), {
                    LEGACY_size: "small",
                    color: "currentColor",
                    ...props,
                    label: formatMessage((0, $b9ZjM.messages).label)
                }),
                ref: triggerRef,
                appearance: "subtle",
                spacing: "compact"
            }),
        shouldRenderToParent: true // This is needed to render the dropdown menu in the same container as the trigger instead of in React.Portal (otherwise domRef.current?.closest('[data-loom-insert-target-marker]' is undefined )
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aLJ1L.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fjnjD.RecordNewLoomItem), {
        onInsertLink: onInsertLink
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3XmZx.default), {
        onShowInsertLoomLinkForm: onShowInsertLoomLinkForm
    })));
};
var $ef860b3667d9df56$export$2e2bcd8739ae039 = $ef860b3667d9df56$var$LoomActionsMenu;

});
parcelRegister("3XmZx", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6bfdb445cb4dca2$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $jYYbf = parcelRequire("jYYbf");

var $iKUFL = parcelRequire("iKUFL");

var $lRq8t = parcelRequire("lRq8t");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $kTpwc = parcelRequire("kTpwc");
const $d6bfdb445cb4dca2$var$InsertExistingLoomItem = /*#__PURE__*/ (0, $eJOHy.memo)(({ onShowInsertLoomLinkForm: onShowInsertLoomLinkForm })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const analyticsEvent = createAnalyticsEvent({
        action: 'clicked',
        actionSubject: 'dropdownItem'
    });
    const handleShowInsertLoomLinkForm = (0, $eJOHy.useCallback)(()=>{
        onShowInsertLoomLinkForm();
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'add-icon-button-dropdown-insert-existing-loom-video-button');
    }, [
        onShowInsertLoomLinkForm,
        analyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jYYbf.default), {
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iKUFL))), {
            color: "currentColor",
            label: "",
            spacing: "spacious"
        }),
        onClick: handleShowInsertLoomLinkForm
    }, formatMessage((0, $kTpwc.default).existingLoomVideo));
});
var $d6bfdb445cb4dca2$export$2e2bcd8739ae039 = $d6bfdb445cb4dca2$var$InsertExistingLoomItem;

});
parcelRegister("kTpwc", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e0d2292f21691d4$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $3e0d2292f21691d4$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    insertExistingLoom: {
        "id": "issue-view-base.content.loom-videos.co-use.loom-actions-menu.insert-existing-loom-item.insert-existing-loom",
        "defaultMessage": "Insert existing Loom"
    },
    existingLoomVideo: {
        "id": "issue-view-base.content.loom-videos.co-use.loom-actions-menu.insert-existing-loom-item.existing-loom-video",
        "defaultMessage": "Existing Loom video"
    }
});

});


parcelRegister("b9ZjM", function(module, exports) {

$parcel$export(module.exports, "messages", () => $4abf61baf9304145$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $4abf61baf9304145$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    label: {
        "id": "issue-view-base.content.loom-videos.co-use.loom-actions-menu.label",
        "defaultMessage": "Add a Loom video"
    }
});

});

parcelRegister("fjnjD", function(module, exports) {

$parcel$export(module.exports, "RecordNewLoomItem", () => $c3422b9f93f3c6fe$export$ebe73d592a7310ff);

var $eJOHy = parcelRequire("eJOHy");

var $lYpjS = parcelRequire("lYpjS");

var $kHdo2 = parcelRequire("kHdo2");

var $iqs6I = parcelRequire("iqs6I");

var $iWwGF = parcelRequire("iWwGF");
const $c3422b9f93f3c6fe$export$ebe73d592a7310ff = ({ onInsertLink: onInsertLink })=>{
    const { loomTouchpointVariant: loomTouchpointVariant } = (0, $lYpjS.useLoomTouchpointVariant)();
    switch(loomTouchpointVariant){
        case (0, $kHdo2.LoomTouchpointVariant).COUSE:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iqs6I.CoUseRecordItem), {
                onInsertLink: onInsertLink
            });
        case (0, $kHdo2.LoomTouchpointVariant).CROSSJOIN:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iWwGF.CrossJoinRecordItem), null);
        default:
            return null;
    }
};

});
parcelRegister("iqs6I", function(module, exports) {

$parcel$export(module.exports, "CoUseRecordItem", () => $18f26b82ce4251d0$export$ba2e8fe50214cb1);

var $eJOHy = parcelRequire("eJOHy");

var $jYYbf = parcelRequire("jYYbf");

var $bTWCd = parcelRequire("bTWCd");

var $jdqdp = parcelRequire("jdqdp");

var $2sLVw = parcelRequire("2sLVw");

var $7ep4S = parcelRequire("7ep4S");

var $lRq8t = parcelRequire("lRq8t");

var $k8E9o = parcelRequire("k8E9o");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $bmoS1 = parcelRequire("bmoS1");

var $1LCJW = parcelRequire("1LCJW");

var $g8sAg = parcelRequire("g8sAg");
const $18f26b82ce4251d0$export$ba2e8fe50214cb1 = /*#__PURE__*/ (0, $eJOHy.memo)(({ onInsertLink: onInsertLink })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const analyticsEvent = createAnalyticsEvent({
        action: 'clicked',
        actionSubject: 'dropdownItem'
    });
    const issueKey = (0, $bmoS1.useIssueKey)();
    const [{ value: issueType }] = (0, $1LCJW.useIssueTypeField)({
        issueKey: issueKey
    });
    const domRef = (0, $eJOHy.useRef)(null);
    const insertTargetMarkerRef = (0, $eJOHy.useRef)(null);
    (0, $eJOHy.useEffect)(()=>{
        /* Once the user clicks the record button (this component),
     * the menu closes and this component, with all its hooks, unmounts.
     * When recording ends renderOnInsertFallbackWhen will run in order to determine
     * whether it is still possible to insert the link or not.
     * This is determined by whether the issue from which recording has started is still mounted.
     * This effect saves an identifier that the callback can use when it runs.
     */ insertTargetMarkerRef.current = domRef.current?.closest('[data-loom-insert-target-marker]')?.getAttribute('data-loom-insert-target-marker');
        if (!insertTargetMarkerRef.current) (0, $gCeeo.fireOperationalAnalytics)(createAnalyticsEvent({}), 'loomSdkInsertTargetMarker notFound', {
            touchpoint: 'loomSectionActionsMenuAddButton'
        });
    }, [
        createAnalyticsEvent
    ]);
    const { openLoomRecorder: openLoomRecorder, recorderState: recorderState } = (0, $k8E9o.useJiraLoomRecorderEntryPoint)({
        entryPointLocation: 'jiraIssueView_loomSectionActionsMenuAddButton',
        onInsert: onInsertLink,
        // intentionally not localized because Loom RecordSDK does not support i18n
        insertButtonText: 'Add video',
        renderOnInsertFallbackWhen: ()=>{
            if (typeof document !== 'undefined') return !insertTargetMarkerRef.current || // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.querySelector('[data-loom-insert-target-marker]')?.getAttribute('data-loom-insert-target-marker') !== insertTargetMarkerRef.current;
            return false;
        },
        experimentalFeatures: {
            jiraIssueType: issueType?.name
        }
    });
    const recordLoomVideo = (0, $eJOHy.useCallback)(()=>{
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'add-icon-button-dropdown-record-a-video-button');
        openLoomRecorder?.();
    }, [
        analyticsEvent,
        openLoomRecorder
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jYYbf.default), {
        key: "loom-section-actions-menu-recording-button",
        ref: domRef,
        elemBefore: recorderState === 'initialising' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ep4S.default), {
            size: "medium",
            label: formatMessage((0, $g8sAg.default).loading),
            testId: "issue-view-base.content.loom-videos.ui.co-use.loom-actions-menu.record-new-loom-item.co-use.recording-button-spinner"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bTWCd))), {
            label: formatMessage((0, $g8sAg.default).videoIcon),
            color: "currentColor",
            spacing: "spacious"
        }),
        onClick: recordLoomVideo,
        isDisabled: recorderState === 'initialising'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2sLVw.default), {
        alignItems: "center",
        gap: "space.050"
    }, formatMessage((0, $g8sAg.default).newLoomVideo), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jdqdp.default), {
        appearance: "new"
    }, formatMessage((0, $g8sAg.default).newLozenge))));
});

});
parcelRegister("g8sAg", function(module, exports) {

$parcel$export(module.exports, "default", () => $7f60870d1caf51b9$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $7f60870d1caf51b9$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    recordANewVideo: {
        "id": "issue-view-base.content.loom-videos.co-use.loom-actions-menu.record-new-loom-item.record-a-new-video",
        "defaultMessage": "Record a video"
    },
    newLoomVideo: {
        "id": "issue-view-base.content.loom-videos.co-use.loom-actions-menu.record-new-loom-item.new-loom-video",
        "defaultMessage": "New Loom video"
    },
    loomVideo: {
        "id": "issue-view-base.content.loom-videos.co-use.loom-actions-menu.record-new-loom-item.loom-video",
        "defaultMessage": "Loom video"
    },
    loading: {
        "id": "issue-view-base.content.loom-videos.co-use.loom-actions-menu.record-new-loom-item.loading",
        "defaultMessage": "Loading"
    },
    videoIcon: {
        "id": "issue-view-base.content.loom-videos.co-use.loom-actions-menu.record-new-loom-item.video-icon",
        "defaultMessage": "Video icon"
    },
    tryLozenge: {
        "id": "issue-view-base.content.loom-videos.co-use.loom-actions-menu.record-new-loom-item.try-lozenge",
        "defaultMessage": "Try"
    },
    addLozenge: {
        "id": "issue-view-base.content.loom-videos.co-use.loom-actions-menu.record-new-loom-item.add-lozenge",
        "defaultMessage": "Add"
    },
    newLozenge: {
        "id": "issue-view-base.content.loom-videos.co-use.loom-actions-menu.record-new-loom-item.new-lozenge",
        "defaultMessage": "New"
    }
});

});


parcelRegister("iWwGF", function(module, exports) {

$parcel$export(module.exports, "CrossJoinRecordItem", () => $fa833eb1a2587c5d$export$73968184b843a034);

var $eJOHy = parcelRequire("eJOHy");

var $lopBx = parcelRequire("lopBx");

var $jYYbf = parcelRequire("jYYbf");

var $bTWCd = parcelRequire("bTWCd");

var $jdqdp = parcelRequire("jdqdp");

var $8nu6j = parcelRequire("8nu6j");
var $lmgo6 = parcelRequire("lmgo6");
var $bQP4O = parcelRequire("bQP4O");
var $1DXK0 = parcelRequire("1DXK0");

var $7jTnu = parcelRequire("7jTnu");

var $lRq8t = parcelRequire("lRq8t");

var $bnpBF = parcelRequire("bnpBF");

var $aAvEW = parcelRequire("aAvEW");

var $c6U64 = parcelRequire("c6U64");

var $bK7le = parcelRequire("bK7le");

var $kHdo2 = parcelRequire("kHdo2");

var $kqe47 = parcelRequire("kqe47");

var $gCeeo = parcelRequire("gCeeo");
var $ftN6c = parcelRequire("ftN6c");

var $lUto7 = parcelRequire("lUto7");

var $g8sAg = parcelRequire("g8sAg");
const $fa833eb1a2587c5d$var$CrossJoinRecordItemWithNestedInteractive = ({ dismissAd: dismissAd })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const crossJoinUrl = (0, $aAvEW.useLoomCrossJoinUrl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const isSiteAdmin = (0, $lUto7.useIsSiteAdmin)();
    const handleClick = (0, $eJOHy.useCallback)(()=>{
        (0, $gCeeo.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'dropdownItem'
        }), 'add-icon-button-dropdown-record-a-video-cross-join-button', {
            isSiteAdmin: isSiteAdmin
        });
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.open(crossJoinUrl, '_blank', 'noreferrer');
    }, [
        createAnalyticsEvent,
        isSiteAdmin,
        crossJoinUrl
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bnpBF.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jYYbf.default), {
        key: "loom-section-actions-menu-cross-join-recording-button",
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bTWCd))), {
            label: formatMessage((0, $g8sAg.default).videoIcon),
            color: "currentColor",
            spacing: "spacious"
        }),
        onClick: handleClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        justifyContent: "space-between",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        alignItems: "center",
        gap: "space.050",
        xcss: $fa833eb1a2587c5d$var$anchorStyles
    }, formatMessage((0, $g8sAg.default).loomVideo), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jdqdp.default), {
        appearance: "new"
    }, formatMessage((0, $g8sAg.default).tryLozenge))), (0, $7jTnu.fg)('enghealth-40167-remove-nested-interactive') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        onClick: (e)=>{
            e.stopPropagation();
        },
        onKeyDown: (e)=>{
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                e.stopPropagation();
            }
        },
        xcss: $fa833eb1a2587c5d$var$pressableStyles,
        tabIndex: 0
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c6U64.default), {
        onDismiss: dismissAd,
        menuLocation: "quick-add"
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bQP4O.default), {
        onClick: (e)=>{
            e.stopPropagation();
        },
        xcss: $fa833eb1a2587c5d$var$pressableStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c6U64.default), {
        onDismiss: dismissAd,
        menuLocation: "quick-add"
    })))));
};
const $fa833eb1a2587c5d$export$73968184b843a034 = ()=>{
    const isFedRampInstance = (0, $lopBx.isFedRamp)();
    const { dismissAd: dismissAd, loomTouchpointVariant: loomTouchpointVariant } = (0, $kqe47.useLoomTouchpointVariantWithAdControls)((0, $bK7le.LOOM_QUICK_ADD_AD_CONTROL_DISMISS_KEY));
    return !isFedRampInstance && loomTouchpointVariant === (0, $kHdo2.LoomTouchpointVariant).CROSSJOIN && ((0, $7jTnu.fg)('enghealth-40167-remove-nested-interactive') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        role: "menu"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fa833eb1a2587c5d$var$CrossJoinRecordItemWithNestedInteractive, {
        dismissAd: dismissAd
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($fa833eb1a2587c5d$var$CrossJoinRecordItemWithNestedInteractive, {
        dismissAd: dismissAd
    }));
};
const $fa833eb1a2587c5d$var$pressableStyles = (0, $1DXK0.xcss)({
    backgroundColor: 'color.background.neutral.subtle',
    padding: 'space.0'
});
const $fa833eb1a2587c5d$var$anchorStyles = (0, $1DXK0.xcss)({
    flexGrow: 1
});

});
parcelRegister("c6U64", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b0626a31997d152$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");

var $aMdh8 = parcelRequire("aMdh8");

var $8nu6j = parcelRequire("8nu6j");
var $5qJVF = parcelRequire("5qJVF");
var $1DXK0 = parcelRequire("1DXK0");

var $c5wvT = parcelRequire("c5wvT");
var $jLzeC = parcelRequire("jLzeC");
var $ckdeJ = parcelRequire("ckdeJ");

var $7jTnu = parcelRequire("7jTnu");

var $lRq8t = parcelRequire("lRq8t");

var $4xbv3 = parcelRequire("4xbv3");
var $gCeeo = parcelRequire("gCeeo");
var $8Plmb = parcelRequire("8Plmb");
var $ftN6c = parcelRequire("ftN6c");

var $lUto7 = parcelRequire("lUto7");

var $afhOp = parcelRequire("afhOp");
const $2b0626a31997d152$var$DATA_PRIVACY_LINK = 'https://www.atlassian.com/legal/privacy-policy';
const $2b0626a31997d152$var$QUICK_MENU_TYPE = 'loom-only';
// AdControlProvider is needed when importing this component to provide the context for the AdControlDropdownMenu
const $2b0626a31997d152$var$AdControls = ({ onDismiss: onDismiss, menuLocation: menuLocation, bannerLocation: bannerLocation })=>{
    const reasonsModalBulletTwoAppify = (0, $7jTnu.fg)('product-terminology-refresh') ? (0, $afhOp.default).reasonsModalBulletTwoAppify : (0, $afhOp.default).reasonsModalBulletTwo;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const isSiteAdmin = (0, $lUto7.useIsSiteAdmin)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const eventAttributes = {
        bannerLocation: bannerLocation,
        menuLocation: menuLocation,
        isSiteAdmin: isSiteAdmin,
        quickMenuType: menuLocation === 'quick-add' ? $2b0626a31997d152$var$QUICK_MENU_TYPE : undefined
    };
    const buttonClicked = createAnalyticsEvent({
        action: 'clicked',
        actionSubject: 'button'
    });
    const linkClicked = createAnalyticsEvent({
        action: 'clicked',
        actionSubject: 'link'
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c5wvT.default), {
        itemId: "loom-videos-banner-ad-controls",
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
                paddingInline: "space.050"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
                ...props,
                appearance: "subtle",
                spacing: "compact",
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aMdh8))), {
                    label: formatMessage((0, $afhOp.default).loomAdControlsTrigger),
                    LEGACY_size: "medium",
                    spacing: "spacious"
                }),
                ref: triggerRef,
                onClick: (event)=>{
                    props.onClick?.(event);
                    (0, $gCeeo.fireUIAnalytics)(buttonClicked, 'adControlsButton', eventAttributes);
                }
            }))
    }, (props)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jLzeC.default), {
            ...props,
            flagProps: {
                title: formatMessage((0, $afhOp.default).dismissFlagTitle),
                description: formatMessage((0, $afhOp.default).dismissFlagDescription)
            },
            onClick: ()=>{
                (0, $gCeeo.fireUIAnalytics)(buttonClicked, 'notInterestedButton', eventAttributes);
                return onDismiss();
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ckdeJ.default), {
            ...props,
            onClick: ()=>{
                (0, $gCeeo.fireUIAnalytics)(buttonClicked, 'whyAmISeeingThisButton', eventAttributes);
            },
            modalProps: {
                title: formatMessage((0, $afhOp.default).reasonsModalTitle),
                body: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4xbv3.ContextualAnalyticsData), {
                    sourceName: "whyAmISeeingThis",
                    sourceType: (0, $466f60259c330878$export$1171103ea9083ffa)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8Plmb.MountEvent), {
                    onMount: (analyticsEvent)=>{
                        (0, $gCeeo.fireScreenAnalytics)(analyticsEvent, eventAttributes);
                    }
                }), formatMessage((0, $afhOp.default).reasonsModalExplanation, {
                    strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5qJVF.default), {
                            weight: "bold"
                        }, chunks)
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("ul", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("li", null, formatMessage((0, $afhOp.default).reasonsModalBulletOne)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("li", null, formatMessage(reasonsModalBulletTwoAppify))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
                    xcss: $2b0626a31997d152$var$linkStyles
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
                    appearance: "link",
                    spacing: "none",
                    href: $2b0626a31997d152$var$DATA_PRIVACY_LINK,
                    target: "_blank",
                    onClick: ()=>{
                        (0, $gCeeo.fireUIAnalytics)(linkClicked, 'dataPrivacyLink');
                    }
                }, formatMessage((0, $afhOp.default).privacyPolicy))))
            }
        }));
    });
};
const $2b0626a31997d152$var$linkStyles = (0, $1DXK0.xcss)({
    marginTop: 'space.150'
});
var $2b0626a31997d152$export$2e2bcd8739ae039 = $2b0626a31997d152$var$AdControls;

});
// SCREENS
const $466f60259c330878$export$f636b5b56f1d624a = 'Screen';
const $466f60259c330878$export$9d2de6eebf7462b5 = 'Drawer';
const $466f60259c330878$export$1171103ea9083ffa = 'Modal';
const $466f60259c330878$export$cae2783c9279926 = 'InlineDialog';
const $466f60259c330878$export$d1123261ca8831d2 = 'Dropdown';
const $466f60259c330878$export$238d30785c4bca84 = 'Banner';
const $466f60259c330878$export$a1562d08625f5d7e = 'UI';
const $466f60259c330878$export$947dac6c72b26f81 = 'TRACK';
const $466f60259c330878$export$f1d537d508d2945a = 'SCREEN';
const $466f60259c330878$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("afhOp", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d1d5ecee0df63db$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $9d1d5ecee0df63db$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    dismissFlagTitle: {
        "id": "loom-utils.ui.ad-controls.dismiss-flag-title",
        "defaultMessage": "Got it, thanks for letting us know"
    },
    dismissFlagDescription: {
        "id": "loom-utils.ui.ad-controls.dismiss-flag-description",
        "defaultMessage": "You won't see this here as often."
    },
    reasonsModalTitle: {
        "id": "loom-utils.ui.ad-controls.reasons-modal-title",
        "defaultMessage": "Why am I seeing this?"
    },
    reasonsModalExplanation: {
        "id": "loom-utils.ui.ad-controls.reasons-modal-explanation",
        "defaultMessage": "We think that <strong>Loom</strong> will improve your team's productivity. The recommendation is based on:"
    },
    reasonsModalBulletOne: {
        "id": "loom-utils.ui.ad-controls.reasons-modal-bullet-one",
        "defaultMessage": "the size of your team"
    },
    reasonsModalBulletTwo: {
        "id": "loom-utils.ui.ad-controls.reasons-modal-bullet-two",
        "defaultMessage": "your existing Atlassian products"
    },
    privacyPolicy: {
        "id": "loom-utils.ui.ad-controls.privacy-policy",
        "defaultMessage": "Learn more about your data privacy with Atlassian"
    },
    loomAdControlsTrigger: {
        "id": "loom-utils.ui.ad-controls.loom-ad-controls-trigger",
        "defaultMessage": "Loom ad controls actions"
    },
    reasonsModalBulletTwoAppify: {
        "id": "loom-utils.ui.ad-controls.reasons-modal-bullet-two-appify",
        "defaultMessage": "your existing Atlassian apps"
    }
});

});





parcelRegister("4n0YE", function(module, exports) {

$parcel$export(module.exports, "LoomVideoInsert", () => $734d9fa9f1639982$export$e7101d4f7ce95cf3);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $48q59 = parcelRequire("48q59");

var $5CSKW = parcelRequire("5CSKW");

var $3L3Os = parcelRequire("3L3Os");
var $fKXve = parcelRequire("fKXve");
var $6svxr = parcelRequire("6svxr");
var $eRpdx = parcelRequire("eRpdx");
var $byJNH = parcelRequire("byJNH");

var $sY9BV = parcelRequire("sY9BV");

var $lRq8t = parcelRequire("lRq8t");

var $l6YWX = parcelRequire("l6YWX");

var $6d9QY = parcelRequire("6d9QY");

var $dtft6 = parcelRequire("dtft6");

var $jKOGj = parcelRequire("jKOGj");
const $734d9fa9f1639982$var$InsertFormActions = ({ onCancel: onCancel })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const formState = (0, $byJNH.useFormState)({
        values: true
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eRpdx.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $48q59.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5CSKW.default), {
        type: "submit",
        appearance: "primary",
        isDisabled: !(0, $jKOGj.canInsert)(formState?.values.url)
    }, formatMessage((0, $dtft6.default).insertButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5CSKW.default), {
        appearance: "subtle",
        onClick: onCancel
    }, formatMessage((0, $dtft6.default).cancelButton))));
};
const $734d9fa9f1639982$export$e7101d4f7ce95cf3 = ({ insertLoomLinkClickedCount: insertLoomLinkClickedCount, loomLinkCount: loomLinkCount, onInsert: onInsert, onCancel: onCancel })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const resetRef = (0, $eJOHy.useRef)();
    const inputRef = (0, $eJOHy.useRef)(null);
    const prevInsertLoomLinkClickedCount = (0, $6d9QY.usePrevious)(insertLoomLinkClickedCount);
    const prevLoomLinkCount = (0, $6d9QY.usePrevious)(loomLinkCount);
    const focusOnInput = ()=>{
        /**
     * without this, the focus will not work as expected
     * issue persisted when using requestAnimationFrame instead of setTimeout
     * root cause is explained here https://hello.atlassian.net/wiki/spaces/~71202082ed214fcb8a401788d49831b11097a6/pages/4011824991/ED-24389+-+React18+editor+focus+issues
     *  - TLDR: When DropDown PopOver unmounts, useFocusManager forcing document focus.
     */ setTimeout(()=>{
            if (inputRef.current !== null) inputRef.current.focus({
                preventScroll: true
            });
        }, 100);
    // 100ms is a safe value to ensure the input is focused and user shouldn't notice the delay
    };
    (0, $eJOHy.useEffect)(()=>{
        // This will hapeen when user has successfully just inserted a link, we should re-focus on the input to let user insert another link
        if (prevLoomLinkCount !== undefined && loomLinkCount > prevLoomLinkCount) focusOnInput();
    }, [
        loomLinkCount,
        prevLoomLinkCount
    ]);
    (0, $eJOHy.useEffect)(()=>{
        // this will handle the mount case (where prevInsertLoomLinkClickedCount is undefined) as well as the insert clicked again case
        if (insertLoomLinkClickedCount !== prevInsertLoomLinkClickedCount) {
            (0, $l6YWX.smoothScrollIntoCenterIfNeeded)(inputRef.current);
            focusOnInput();
        }
    }, [
        insertLoomLinkClickedCount,
        prevInsertLoomLinkClickedCount
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3L3Os.default), {
        onSubmit: ({ url: url })=>{
            if ((0, $jKOGj.canInsert)(url)) {
                const trimmedUrl = url.trim(); // a url with leadning/trailing spaces is valid but we want to trim it before inserting, otherwise the endpoint will reject it
                onInsert(trimmedUrl);
                // reset the text field after submitting
                resetRef.current?.();
            }
        }
    }, ({ formProps: formProps, reset: reset })=>{
        resetRef.current = reset;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("form", {
            ...formProps,
            "data-testid": "issue-view-base.content.loom-videos.ui.co-use.loom-video-insert.form",
            className: (0, $hcewu.default)([
                "_18z1t94y _1wpvt94y _ewaut94y _1hcdt94y"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6svxr.default), {
            name: "url",
            defaultValue: "",
            isRequired: true,
            validate: (value)=>(0, $jKOGj.shouldShowInvalidMessage)(value) ? 'INVALID_URL' : undefined
        }, ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $sY9BV.default), {
                ref: inputRef,
                ...fieldProps,
                placeholder: formatMessage((0, $dtft6.default).placeholderText),
                "aria-label": formatMessage((0, $dtft6.default).placeholderText),
                autoComplete: "off"
            }), error === 'INVALID_URL' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fKXve.ErrorMessage), null, formatMessage((0, $dtft6.default).invalidUrlText)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($734d9fa9f1639982$var$InsertFormActions, {
            onCancel: onCancel
        }));
    });
};
const $734d9fa9f1639982$var$formStyles = null;

});
parcelRegister("eRpdx", function(module, exports) {

$parcel$export(module.exports, "default", () => $6411efa125c19813$export$2e2bcd8739ae039);
/* form-footer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $6411efa125c19813$var$formFooterWrapperStyles = null;
const $6411efa125c19813$var$justifyContentStyles = null;
function $6411efa125c19813$export$2e2bcd8739ae039({ align: align = 'end', children: children }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)("footer", {
        className: (0, $hcewu.default)([
            "_1e0c1txw _1bahesu3 _1pfh1ejb",
            align === 'start' && "_1bah1y6m"
        ]),
        children: children
    });
}

});

parcelRegister("dtft6", function(module, exports) {

$parcel$export(module.exports, "default", () => $f651ef312f54615c$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $f651ef312f54615c$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    insertButton: {
        "id": "issue-view-base.content.loom-videos.co-use.loom-video-insert.insert-button",
        "defaultMessage": "Insert"
    },
    cancelButton: {
        "id": "issue-view-base.content.loom-videos.co-use.loom-video-insert.cancel-button",
        "defaultMessage": "Cancel"
    },
    placeholderText: {
        "id": "issue-view-base.content.loom-videos.co-use.loom-video-insert.placeholder-text",
        "defaultMessage": "Add a Loom link"
    },
    invalidUrlText: {
        "id": "issue-view-base.content.loom-videos.co-use.loom-video-insert.invalid-url-text",
        "defaultMessage": "Hold on, let's try a valid Loom link instead."
    }
});

});

parcelRegister("jKOGj", function(module, exports) {

$parcel$export(module.exports, "shouldShowInvalidMessage", () => $ab8be0cfd1c31c06$export$4b698f3c1d0fae75);
$parcel$export(module.exports, "canInsert", () => $ab8be0cfd1c31c06$export$b4d1262a40ad21d4);
/**
 * Determines if the URL is valid based on the standard Loom share URL pattern
 * @param shareUrl
 * @returns boolean
 * @example isUrlValid('https://www.loom.com/share/6d1794b0dd4c4a8495efa20d090c1602') // true
 * @example isUrlValid('https://stage.loom.com/share/Test-Recording-Video-9b7af208f71f45379a9f297bd065397a') // true
 * @example isUrlValid('https://www.youtube.com/watch?v=Hd0JflMdqyM') // false
 */ const $ab8be0cfd1c31c06$export$c4ea027afed2fe4a = (shareUrl)=>{
    // strip query string
    try {
        const loomShareUrlPattern = /^\s*http(s)?:\/\/(www\.|stage\.)?(loom.com)\/(embed|share)\/(.+-)?([a-fA-F0-9]{32})(?:\?|$)/;
        const url = new URL(shareUrl);
        url.search = '';
        return loomShareUrlPattern.test(url.toString());
    } catch  {
        return false;
    }
};
const $ab8be0cfd1c31c06$export$4b698f3c1d0fae75 = (shareUrl)=>{
    if (shareUrl === '') // we don't want to show an error message when the field is empty. especially when 'reset' is called after submitting, url is set to '' after that
    return false;
    if (shareUrl === undefined) return true;
    return !$ab8be0cfd1c31c06$export$c4ea027afed2fe4a(shareUrl);
};
const $ab8be0cfd1c31c06$export$b4d1262a40ad21d4 = (url)=>!$ab8be0cfd1c31c06$export$4b698f3c1d0fae75(url) && url?.trim() !== '';

});


parcelRegister("7mvFA", function(module, exports) {

$parcel$export(module.exports, "LoomVideosList", () => $35f3d9a190707c8d$export$cc3e92fb04a15d0);

var $eJOHy = parcelRequire("eJOHy");

var $8TCRV = parcelRequire("8TCRV");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $gCeeo = parcelRequire("gCeeo");

var $kaDah = parcelRequire("kaDah");

var $3c4kQ = parcelRequire("3c4kQ");
const $35f3d9a190707c8d$export$cc3e92fb04a15d0 = ({ links: links, animate: animate, offset: offset, onScroll: onScroll, onDeleteLink: onDeleteLink })=>{
    const [pendingDeleteId, setPendingDeleteId] = (0, $eJOHy.useState)(null);
    if (links.length === 0) return null;
    const handleDeleteLink = (id)=>{
        setPendingDeleteId(id);
    };
    const handleDeleteConfirm = (_, analyticsEvent)=>{
        if (pendingDeleteId !== null) onDeleteLink(pendingDeleteId);
        setPendingDeleteId(null);
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'loom-video-lists-confirm-modal-delete-video');
    };
    const handleDeleteCancel = (_, analyticsEvent)=>{
        setPendingDeleteId(null);
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'loom-video-lists-confirm-modal-cancel-delete-video');
    };
    // when there is only a single video, make it fill the available
    const videoCards = links.length === 1 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        testId: "issue-view-base.content.loom-videos.ui.co-use.loom-videos-list.single",
        xcss: $35f3d9a190707c8d$var$singleCardStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3c4kQ.default), {
        link: links[0],
        onDeleteLink: handleDeleteLink
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8TCRV.FilmstripView), {
        onScroll: onScroll,
        animate: animate,
        offset: offset
    }, links.slice().reverse() // we want the leftmost video to be the most recent one
    .map((l)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            key: l.id,
            testId: "issue-view-base.content.loom-videos.ui.co-use.loom-videos-list.multi",
            xcss: $35f3d9a190707c8d$var$multiCardStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3c4kQ.default), {
            link: l,
            onDeleteLink: handleDeleteLink
        }))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, videoCards, pendingDeleteId !== null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kaDah.default), {
        onConfirm: handleDeleteConfirm,
        onCancel: handleDeleteCancel
    }));
};
const $35f3d9a190707c8d$var$singleCardStyles = (0, $1DXK0.xcss)({
    maxWidth: '700px',
    minWidth: '380px',
    aspectRatio: '1.57894736842',
    marginBottom: 'space.100'
});
const $35f3d9a190707c8d$var$multiCardStyles = (0, $1DXK0.xcss)({
    width: '380px',
    height: '240px',
    marginBottom: 'space.100'
});

});
parcelRegister("kaDah", function(module, exports) {

$parcel$export(module.exports, "default", () => $d13ddc03c6ad2049$export$2e2bcd8739ae039);
// ported from jira/src/packages/issue/issue-view-common-views/src/web-link-line-card-group/delete-modal/index.tsx

var $eJOHy = parcelRequire("eJOHy");

var $5CSKW = parcelRequire("5CSKW");

var $ik0CA = parcelRequire("ik0CA");
var $kseeK = parcelRequire("kseeK");
var $2qG7I = parcelRequire("2qG7I");
var $5a9Ro = parcelRequire("5a9Ro");

var $aC4Bh = parcelRequire("aC4Bh");

var $2ZGUP = parcelRequire("2ZGUP");

var $7jTnu = parcelRequire("7jTnu");

var $lRq8t = parcelRequire("lRq8t");

var $4Q1P2 = parcelRequire("4Q1P2");
const $d13ddc03c6ad2049$export$73392e09138fecd6 = ({ onConfirm: onConfirm, onCancel: onCancel })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const headerMessage = formatMessage((0, $4Q1P2.messages).headerMessage);
    const contentMessage = formatMessage((0, $7jTnu.fg)('jira-issue-terminology-refresh-m3') ? (0, $4Q1P2.messages).contentMessageIssueTermRefresh : (0, $4Q1P2.messages).contentMessage);
    const confirmActionText = formatMessage((0, $4Q1P2.messages).confirmActionText);
    const cancelActionText = formatMessage((0, $4Q1P2.messages).cancelActionText);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2ZGUP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aC4Bh.JiraModal), {
        messageId: "issue-view-base.content.loom-videos.ui.co-use.loom-videos-list.delete-modal.modal-dialog",
        messageType: "transactional",
        onClose: onCancel,
        width: "small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2qG7I.default), {
        hasCloseButton: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5a9Ro.default), {
        appearance: "danger"
    }, headerMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ik0CA.default), null, contentMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kseeK.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5CSKW.default), {
        appearance: "primary",
        onClick: onConfirm
    }, confirmActionText), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5CSKW.default), {
        appearance: "subtle",
        onClick: onCancel
    }, cancelActionText)))));
};
var $d13ddc03c6ad2049$export$2e2bcd8739ae039 = $d13ddc03c6ad2049$export$73392e09138fecd6;

});
parcelRegister("4Q1P2", function(module, exports) {

$parcel$export(module.exports, "messages", () => $9ab055d3c4b6eee0$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $9ab055d3c4b6eee0$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    headerMessage: {
        "id": "issue-view-base.content.loom-videos.co-use.loom-videos-list.delete-modal.header-message",
        "defaultMessage": "Remove this Loom video link?"
    },
    contentMessage: {
        "id": "issue-view-base.content.loom-videos.co-use.loom-videos-list.delete-modal.content-message",
        "defaultMessage": "This will unlink the video from the issue."
    },
    confirmActionText: {
        "id": "issue-view-base.content.loom-videos.co-use.loom-videos-list.delete-modal.confirm-action-text",
        "defaultMessage": "Remove"
    },
    cancelActionText: {
        "id": "issue-view-base.content.loom-videos.co-use.loom-videos-list.delete-modal.cancel-action-text",
        "defaultMessage": "Cancel"
    },
    contentMessageIssueTermRefresh: {
        "id": "issue-view-base.content.loom-videos.co-use.loom-videos-list.delete-modal.content-message-issue-term-refresh",
        "defaultMessage": "This will unlink the video."
    }
});

});


parcelRegister("3c4kQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $92d07915158ba607$export$2e2bcd8739ae039);

var $284TU = parcelRequire("284TU");

var $1IADZ = parcelRequire("1IADZ");

var $77EKS = parcelRequire("77EKS");
var $92d07915158ba607$export$2e2bcd8739ae039 = (0, $284TU.connect)(null, (dispatch, { link: { id: linkId } })=>({
        onDeleteWebLinkRetry: ()=>{
            dispatch((0, $1IADZ.deleteWebLinkRequest)(linkId));
        }
    }))((0, $77EKS.LoomVideoCard));

});
parcelRegister("77EKS", function(module, exports) {

$parcel$export(module.exports, "LoomVideoCard", () => $36478d79f5fa9b95$export$f91bff7396e50278);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $Ay1uj = parcelRequire("Ay1uj");

var $6zhpo = parcelRequire("6zhpo");

var $jkYbX = parcelRequire("jkYbX");

var $guChT = parcelRequire("guChT");

var $4cFYC = parcelRequire("4cFYC");

var $7jTnu = parcelRequire("7jTnu");

var $hqYEY = parcelRequire("hqYEY");

var $gYnSx = parcelRequire("gYnSx");

var $hrodw = parcelRequire("hrodw");
var $bILK0 = parcelRequire("bILK0");

var $lRq8t = parcelRequire("lRq8t");

var $6d9QY = parcelRequire("6d9QY");

var $gCeeo = parcelRequire("gCeeo");

var $avBqB = parcelRequire("avBqB");

var $4trsm = parcelRequire("4trsm");

var $dIjrd = parcelRequire("dIjrd");
const $36478d79f5fa9b95$export$f30594ea7fd7a441 = 'deleteLoomVideoLinkFailed';
const $36478d79f5fa9b95$export$3ba67dfd4f739fe9 = (0, $hqYEY.metrics).interaction({
    key: 'issue-view.loom-videos-card-load'
});
const $36478d79f5fa9b95$export$f91bff7396e50278 = ({ link: link, onDeleteLink: onDeleteLink, onDeleteWebLinkRetry: onDeleteWebLinkRetry })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)(); // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const { deleteFailed: deleteFailed } = link;
    const prevDeleteFailed = (0, $6d9QY.usePrevious)(deleteFailed);
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $bILK0.useFlagsService)();
    const [errorStatus, setErrorStatus] = (0, $eJOHy.useState)(undefined);
    const [isCardLoaded, setIsCardLoaded] = (0, $eJOHy.useState)(false);
    const [isDeleteButtonClicked, setDeleteButtonClicked] = (0, $eJOHy.useState)(false);
    (0, $eJOHy.useEffect)(()=>{
        isCardLoaded ? $36478d79f5fa9b95$export$3ba67dfd4f739fe9.stop() : $36478d79f5fa9b95$export$3ba67dfd4f739fe9.start();
    }, [
        isCardLoaded
    ]);
    (0, $eJOHy.useEffect)(()=>{
        errorStatus && (0, $gYnSx.default)({
            meta: {
                id: 'loomVideoCardLoad',
                packageName: 'jiraIssueViewBase',
                teamName: 'bento'
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }, [
        errorStatus
    ]);
    const handleError = ({ status: status })=>{
        setErrorStatus(status);
        setIsCardLoaded(true);
    };
    const handleResolve = ()=>{
        setIsCardLoaded(true);
    };
    const handleDeleteLink = (_, analyticsEvent)=>{
        (0, $gCeeo.fireUIAnalytics)(analyticsEvent, 'delete-loom-video-card-button');
        onDeleteLink(link.id);
        setDeleteButtonClicked(true);
    };
    const showDeleteErrorFlag = (0, $eJOHy.useCallback)(()=>{
        const flagId = (0, $hrodw.toFlagId)($36478d79f5fa9b95$export$f30594ea7fd7a441);
        showFlag({
            messageId: 'issue-view-base.content.loom-videos.ui.co-use.loom-videos-list.loom-video-card.show-flag.warning.delete-error',
            messageType: 'transactional',
            id: flagId,
            title: (0, $dIjrd.messages).deleteErrorHeading,
            description: (0, $dIjrd.messages).errorBody,
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jkYbX))), {
                label: formatMessage((0, $dIjrd.messages).iconLabel),
                color: "var(--ds-icon-warning, #E56910)",
                spacing: "spacious"
            }),
            type: 'warning',
            isAutoDismiss: true,
            actions: [
                {
                    content: (0, $dIjrd.messages).retryAction,
                    onClick: ()=>{
                        dismissFlag(flagId);
                        onDeleteWebLinkRetry();
                    }
                },
                {
                    content: (0, $dIjrd.messages).cancelAction,
                    onClick: ()=>{
                        dismissFlag(flagId);
                    }
                }
            ]
        });
    }, [
        onDeleteWebLinkRetry,
        dismissFlag,
        showFlag,
        formatMessage
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (deleteFailed && deleteFailed !== prevDeleteFailed) {
            showDeleteErrorFlag();
            (0, $gYnSx.default)({
                meta: {
                    id: 'loomVideoCardDeletion',
                    packageName: 'jiraIssueViewBase',
                    teamName: 'bento'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
    }, [
        deleteFailed,
        prevDeleteFailed,
        showDeleteErrorFlag
    ]);
    const card = errorStatus === 'errored' || errorStatus === 'unauthorized' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4trsm.LoomErrorCard), {
        url: link.href
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4cFYC.Card), {
        url: link.href,
        appearance: "embed",
        platform: "web",
        frameStyle: "show",
        inheritDimensions: true,
        onError: handleError,
        onResolve: handleResolve
    });
    const loomVideoCard = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        className: (0, $hcewu.default)([
            "_11c82smr _4t3i1osq _kqswh2mm _vtqp1osq _8kgukb7n _wjvokb7n"
        ])
    }, card, isCardLoaded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        "data-show-on-hover": "true",
        className: (0, $hcewu.default)([
            "_kqswstnw _1bsboahv _19pk1b66 _2hwx1b66 _otyr1b66 _18u01b66 _4t3i1ejb _1pbykb7n _154iidpf _1xi2idpf _1e0c1txw _4cvr1h6o _1bahesu3 _tzy4idpf _1itk11xj"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6zhpo))),
        appearance: "subtle",
        label: formatMessage((0, $dIjrd.messages).removeButtonLabel),
        spacing: "compact",
        onClick: handleDeleteLink,
        onFocus: (e)=>{
            // after we click cancel button in delete confirmation dialog, the focus goes back to this close icon button
            if (!isDeleteButtonClicked) return;
            e.target.blur();
            setDeleteButtonClicked(false);
        }
    })));
    return (0, $7jTnu.fg)('jira-issue-view-twc-spotlight-tour') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $guChT.default), {
        name: (0, $avBqB.TWC_SPOTLIGHT_TARGETS).LINKED_VIDEO_PLAYER
    }, loomVideoCard) : loomVideoCard;
};
// can't use xcss here since we have to nest CSS for .loader-wrapper
const $36478d79f5fa9b95$var$wrapperStyles = null; // this is a little absolute positioned element on the top-right of the smart card to show an "x" button
const $36478d79f5fa9b95$var$closeWrapperStyles = null;

});
parcelRegister("4trsm", function(module, exports) {

$parcel$export(module.exports, "LoomErrorCard", () => $241fb5b4d49d45fc$export$fd3b8d345f1c673);

var $eJOHy = parcelRequire("eJOHy");

var $80DPg = parcelRequire("80DPg");

var $25YjY = parcelRequire("25YjY");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $2l8bu = parcelRequire("2l8bu");

var $lRq8t = parcelRequire("lRq8t");

var $1MNtF = parcelRequire("1MNtF");

var $8VkeW = parcelRequire("8VkeW");
const $241fb5b4d49d45fc$export$fd3b8d345f1c673 = ({ url: url })=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2l8bu.ExpandedFrame), {
        allowScrollBar: true,
        setOverflow: true,
        frameStyle: "show",
        href: url,
        inheritDimensions: true,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($25YjY))), {
            label: "Unlink",
            color: "var(--ds-icon, #44546F)"
        }),
        testId: "issue-view-base.content.loom-videos.ui.co-use.loom-videos-list.loom-video-card.loom-error-card.error-view",
        text: url
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $241fb5b4d49d45fc$var$contentStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($80DPg))), {
        label: "Error",
        color: "var(--ds-icon, #44546F)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1MNtF.SectionHeadingTitle), null, formatMessage((0, $8VkeW.messages).loomCardErrorHeading))));
};
const $241fb5b4d49d45fc$var$contentStyles = (0, $1DXK0.xcss)({
    textAlign: 'center',
    alignContent: 'center',
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    height: '100%'
});

});
parcelRegister("25YjY", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ae3bff1d1955acd002e5417a314968c1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $186ad6f022280ede$var$_react = $186ad6f022280ede$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $186ad6f022280ede$var$_baseNew = $186ad6f022280ede$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $186ad6f022280ede$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LinkBroken".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for removing a link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $186ad6f022280ede$var$LinkBrokenIcon = (props)=>/*#__PURE__*/ $186ad6f022280ede$var$_react.default.createElement($186ad6f022280ede$var$_baseNew.default, Object.assign({
        name: "LinkBrokenIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6 1v3H4.5V1zm2.22 1.22a3.932 3.932 0 1 1 5.56 5.56l-.75.75-1.06-1.06.75-.75a2.432 2.432 0 0 0-3.44-3.44l-.75.75-1.06-1.06zM1 4.5h3V6H1zm1.22 3.72.75-.75 1.06 1.06-.75.75a2.432 2.432 0 0 0 3.44 3.44l.75-.75 1.06 1.06-.75.75a3.932 3.932 0 1 1-5.56-5.56M15 11.5h-3V10h3zM10 15v-3h1.5v3z" clip-rule="evenodd"/>`
    }, props));
$186ad6f022280ede$var$LinkBrokenIcon.displayName = 'LinkBrokenIcon';
var $186ad6f022280ede$var$_default = module.exports.default = $186ad6f022280ede$var$LinkBrokenIcon;

});


parcelRegister("dIjrd", function(module, exports) {

$parcel$export(module.exports, "messages", () => $ff35b5fd6799f979$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $ff35b5fd6799f979$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    removeButtonLabel: {
        "id": "issue-view-base.content.loom-videos.co-use.loom-videos-list.loom-video-card.remove-button-label",
        "defaultMessage": "Remove linked Loom"
    },
    deleteErrorHeading: {
        "id": "issue-view-base.content.loom-videos.co-use.loom-videos-list.loom-video-card.delete-error-heading",
        "defaultMessage": "Loom video not removed"
    },
    errorBody: {
        "id": "issue-view-base.content.loom-videos.co-use.loom-videos-list.loom-video-card.error-body",
        "defaultMessage": "Wait a few moments, then give it another try."
    },
    iconLabel: {
        "id": "issue-view-base.content.loom-videos.co-use.loom-videos-list.loom-video-card.icon-label",
        "defaultMessage": "warning"
    },
    retryAction: {
        "id": "issue-view-base.content.loom-videos.co-use.loom-videos-list.loom-video-card.retry-action",
        "defaultMessage": "Try again"
    },
    cancelAction: {
        "id": "issue-view-base.content.loom-videos.co-use.loom-videos-list.loom-video-card.cancel-action",
        "defaultMessage": "Cancel"
    }
});

});









//# sourceMappingURL=async-loom-videos-panel.0358f873.js.map
